import {
  IconCalendarAlt,
  IconEuroCircle,
  IconFileShieldAlt,
  IconNoEntry,
} from '@maia/icons';
import { ClaimDto } from '@maia/shared';
import { cardStyles, SectionWithHeader, Spec, SpecList } from '@maia/ui';
import { formatCurrency, formatDate } from '@maia/utils';
import { twMerge } from 'tailwind-merge';

type BasicClaimInformationProps = {
  claim: ClaimDto;
};

export function DetailsClaimInformation(props: BasicClaimInformationProps) {
  const { claim } = props;

  return (
    <SectionWithHeader title="Ingezonden gegevens">
      <div
        className={twMerge(
          cardStyles({ variant: 'flat' }),
          'p-20 flex gap-x-12',
        )}
      >
        <SpecList className="grow">
          <Spec
            className="grid grid-cols-2"
            title="Datum schade"
            icon={IconCalendarAlt}
            value={formatDate(claim.occurredAt)}
          />
          <Spec
            className="grid grid-cols-2"
            title="Type verzekering"
            icon={IconFileShieldAlt}
            value={claim.insurance.title}
          />
          <Spec
            className="grid grid-cols-2"
            title="Activiteit"
            icon={IconNoEntry}
            value={claim.activity}
          />
          {/* <Spec
            className="grid grid-cols-2"
            title="Oorzaak categorie"
            icon={IconCrosshairAlt}
            value="NOT IMPLEMENTED - Oorzaak categorie!"
          /> */}
          <Spec
            className="grid grid-cols-2"
            title="Indicatie schadebedrag"
            icon={IconEuroCircle}
            value={formatCurrency(claim.claimAmountIndication)}
          />
        </SpecList>
      </div>
    </SectionWithHeader>
  );
}
